import type { BadgeVariant } from '../../components/ui';

/** Tông của nhãn trạng thái xác thực hai lớp: bật là `success`, chưa bật là `neutral`. */
export const TONE_XAC_THUC_HAI_LOP: Record<'bat' | 'chuaBat', BadgeVariant> = {
  bat: 'success',
  chuaBat: 'neutral',
};

/**
 * Tông của nhãn "cập nhật trực tiếp" cạnh danh sách phiên. Chỉ ba trạng thái
 * có nhãn; kênh tắt hay đã dừng (dữ liệu mẫu, 403) thì không hiện gì — danh
 * sách vẫn tự tải lại định kỳ, không có gì sai để báo.
 */
export const TONE_KENH_SU_KIEN: Record<'dangKetNoi' | 'trucTiep' | 'matKetNoi', BadgeVariant> = {
  dangKetNoi: 'neutral',
  trucTiep: 'success',
  matKetNoi: 'warning',
};

/**
 * Tông của nhãn trạng thái mã khôi phục, cùng luật với xác thực hai lớp: đã
 * tạo là `success`, chưa tạo là `neutral`. Không rõ thì không có nhãn —
 * không có gì chắc chắn để nói.
 */
export const TONE_MA_KHOI_PHUC: Record<'daTao' | 'chuaTao', BadgeVariant> = {
  daTao: 'success',
  chuaTao: 'neutral',
};
